import { IconButton } from "@mui/material";
import { motion, Variants } from "motion/react";
import { Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";
import { NavbarTooltip } from "~/components/navbar-tooltip";
import { MouseEventHandler } from "react";

interface GlobalSearchIconProps {
  handleToggleFocus: MouseEventHandler<HTMLButtonElement>;
  isFocused: boolean;
}

export default function GlobalSearchIcon({
  handleToggleFocus,
  isFocused,
}: GlobalSearchIconProps) {
  return (
    <NavbarTooltip title="Search">
      <IconButton size="large" onClick={handleToggleFocus} color="inherit">
        <div
          style={{
            overflow: "hidden",
            height: "24px",
          }}
        >
          <motion.div
            variants={iconVariants}
            animate={isFocused ? "open" : "closed"}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <SearchIcon />
            <CloseIcon />
          </motion.div>
        </div>
      </IconButton>
    </NavbarTooltip>
  );
}

const iconVariants: Variants = {
  closed: { y: 0 },
  open: { y: "-50%" },
};
